import Vue from "vue"
import App from "./App.vue"
import router from "./router"
import { createProvider } from "./vue-apollo"
import store from "./store"
import "./filters"

Vue.config.productionTip = false

import BootstrapVue from "bootstrap-vue"
import "bootstrap/dist/css/bootstrap.css"
import "bootstrap-vue/dist/bootstrap-vue.css"
Vue.use(BootstrapVue)

import VueSlickCarousel from "vue-slick-carousel"
import "vue-slick-carousel/dist/vue-slick-carousel.css"
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css"
Vue.component("VueSlickCarousel", VueSlickCarousel)

import "./components/forms/vueformulate"

import VueToast from "vue-toast-notification"
import "vue-toast-notification/dist/theme-default.css"
Vue.use(VueToast, {
	position: "top-right"
})

import VueSocialSharing from "vue-social-sharing"
Vue.use(VueSocialSharing)

import VueQrcode from "@chenfengyuan/vue-qrcode"
Vue.component(VueQrcode.name, VueQrcode)

import VuejsDialog from "vuejs-dialog"
import "vuejs-dialog/dist/vuejs-dialog.min.css"
Vue.use(VuejsDialog, {
	okText: "Confirmar",
	cancelText: "Cancelar",
	html: true,
	animation: "fade"
})

import Parallax from "vue-parallaxy"
Vue.component("parallax", Parallax)

import vClickOutside from "v-click-outside"
Vue.use(vClickOutside)

import omitDeep from "omit-deep"
Vue.prototype.$omitDeep = omitDeep

import VueMeta from "vue-meta"
Vue.use(VueMeta)

import VueI18n from "vue-i18n"
Vue.use(VueI18n)

const i18n = new VueI18n({
	locale: process.env.VUE_APP_I18N_LOCALE || "en",
	fallLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || "en"
})

let moment = require("moment-timezone")
require("moment/locale/es")
moment.tz.setDefault("America/Montevideo")

moment.locale("es", {
	weekdaysShort: "Dom_Lun_Mar_Mie_Jue_Vie_Sab".split("_")
})

Vue.use(require("vue-moment"), { moment })

import "@/assets/fontastic/styles.css"
import "@/assets/forms.scss"
import "@/assets/forms.css"
import "@/assets/style.css"

import Sticky from "vue-sticky-directive"
Vue.use(Sticky)

import DatePicker from "vue2-datepicker"
import "vue2-datepicker/locale/es"
import "vue2-datepicker/index.css"
Vue.component("DatePicker", DatePicker)

import VueGtag from "vue-gtag"
Vue.use(
	VueGtag,
	{
		config: { id: "UA-219126334-1" }
	},
	router
)

Vue.prototype.$language = "es"
// cargo el l18n de la barra
router.beforeEach((to, from, next) => {
	Vue.prototype.$language = to.params.lang
	let language = to.params.lang
	if (!language) {
		language = "es"
	}
	i18n.locale = language
	i18n.silentTranslationWarn = true
	moment.locale(i18n.locale)
	next()
})

new Vue({
	i18n,
	router,
	store,
	apolloProvider: createProvider(),
	render: (h) => h(App)
}).$mount("#app")
